import React, { useState } from "react";
import NavbarTop from "../Components/NavbarTop";
import { ReactComponent as EyeIcon } from "../../assets/login/eye.svg";
import { ReactComponent as EyeOffIcon } from "../../assets/login/eyeOff.svg";
import { ReactComponent as Silhouette } from "../../assets/login/Silhouette.svg";
import { ReactComponent as SignupGuy } from "../../assets/illustration/SignupGuy.svg";
import { Link } from "react-router-dom";
import logo from "../../assets/logo/radis.png";
import MainButton from "../../commonComponents/MainButton.js";
import { ToastWarn } from "../../commonComponents/ToastHelper";

// NAVIGATE
import { useNavigate } from "react-router-dom";

// REDUX
import { useDispatch } from "react-redux";
import { sendSignInLinkEmail, clearStore, setCguOk } from "../../redux/actions/authActions";
import { setPersistenceSignIn } from "../../redux/actions/authActions";

import storage from "redux-persist/lib/storage";
import { auth, db_firestore } from "../../firebase/config";

// TEMP
// import { sendSignInLinkToEmail } from "firebase/auth";

const SigninPage = () => {
  const navigate = useNavigate();

  //
  const [creds, setCreds] = useState({ emailAddress: "", password: { value: "", showPassword: false } });
  const [signInPersistence, setSigninPersistence] = useState(false);
  const [cgau, set_cgau] = useState(false);

  // REDUX
  const dispatch = useDispatch();
  const sendSignInLinkEmail_rd = (item) => dispatch(sendSignInLinkEmail(item));
  // const setCguOk_rd = () => dispatch(setCguOk());
  const clearStore_rd = (item) => dispatch(clearStore(item));
  // const setPersistenceSignIn_rd = item => dispatch(setPersistenceSignIn(item));

  // const sendPasswordResetLink_rd = item => dispatch(sendPasswordResetLink(item));

  return (
    <>
      {/* <NavbarTop /> */}
      <div className="flex justify-center w-full h-full font-Poppins-Regular">
        {/* <div className='bg-white h-[580px] w-[960px] absolute top-[155px] shadow-lg rounded-2xl'> */}
        <div className="bg-white h-[580px] w-[960px] absolute top-[120px] shadow-lg rounded-2xl">
          <div className="h-full w-[400px] relative left-[15px] flex justify-center">
            <div className="relative top-20 h-[490px]">
              <h1 className="font-bold relative top-[20px] text-2xl font-Poppins-SemiBold">Connectez-vous</h1>

              <div className="relative flex align-middle top-[30px]">
                <p className="text-xs font-Poppins-Light">Pas encore de compte ?{/* <a href='https://tripetto.app/run/RHFT8IWYRY'> */}</p>
                <button onClick={() => window.open("https://meetings-eu1.hubspot.com/slachhab", "_blank", "noopener,noreferrer")} className="text-[#169A6A] text-xs relative left-1 font-Poppins-Light">
                  Inscrivez-vous
                </button>
              </div>

              <form action="" className="w-[290px]">
                <div className="email pt-12 block ">
                  <label className="font-Poppins-SemiBold">Adresse email</label>
                  <input
                    className="input mt-2 text-ms rounded-lg block border-[1px] border-[#BEC4C] font-Poppins-Regular border-gray-300 focus:border-pitch-black  py-3 px-3 w-full focus:outline-none "
                    // className='rounded-lg border-[1px] border-[#BEC4C] w-[290px] font-Poppins-Regular p-[10px]'
                    type="email"
                    value={creds.emailAddress}
                    onChange={(e) => setCreds((prev) => ({ ...prev, emailAddress: e.target.value }))}
                    placeholder="email@company.com"
                    autoComplete="email"
                  />
                </div>
                <div className="password_2 block pt-6 relative">
                  {/* <label className="font-Poppins-SemiBold">Mot de passe</label>
                  <div className="justify-between flex flex-row items-center">
                    <input
                      className="input mt-2 rounded-lg block border-[1px] border-[#BEC4C] font-Poppins-Regular border-gray-300 focus:border-pitch-black  py-3 px-3 w-full focus:outline-none "
                      type={creds.password.showPassword ? "text" : "password"}
                      value={creds.password.value}
                      onChange={(e) =>
                        setCreds((prev) => {
                          const temp = { ...prev };
                          temp["password"]["value"] = e.target.value;
                          return temp;
                        })
                      }
                    />
                    <div
                      className={"icon_button absolute left-[255px] " + (creds.password.showPassword ? "bottom-[53px]" : "bottom-[51px]")}
                      onClick={() =>
                        setCreds((prev) => {
                          const temp = { ...prev };
                          console.log(temp);
                          temp["password"]["showPassword"] = !temp["password"]["showPassword"];
                          return temp;
                        })
                      }
                    >
                      {creds.password.showPassword ? <EyeIcon className="h-4" /> : <EyeOffIcon className="h-5" />}
                    </div>
                  </div> */}

                  {/* <div className="justify-between flex flex-row items-center mt-5"> */}
                  <div className="text-[#BEC4C] text-xs font-Poppins-Light relative flex-row flex">
                    <input onChange={() => set_cgau(!cgau)} checked={cgau} className="mr-2 bg-[#BEC4C] font-Poppins-Regular" type="checkbox" />
                    <a href="https://drive.google.com/file/d/1NYo2BVRvR8C6GnKW_349XoHg-LvslO9p/view?usp=sharing" target="_blank" rel="noreferrer">
                      <u>Conditions générales d'utilisation</u>
                    </a>
                  </div>
                  <div className="justify-between flex flex-row items-center mt-[5px]">
                    <div className="text-[#BEC4C] text-xs font-Poppins-Light relative flex-row flex">
                      <input onChange={() => setSigninPersistence(!signInPersistence)} checked={signInPersistence} className="mr-2 bg-[#BEC4C] font-Poppins-Regular" type="checkbox" />
                      <p>Rester connecté</p>
                    </div>

                    {/* <a
                      onClick={() => {
                        navigate("/ForgotPassword");
                      }}
                      style={{ cursor: "pointer" }}
                      className="text-[#BEC4C] text-xs font-Poppins-Light"
                    >
                      Mot de passe oublié
                    </a> */}
                  </div>
                </div>

                {/* <div className="flex items-center justify-center mt-8 h-[56px]"> */}
                <div className="flex items-center justify-center mt-14 h-[56px]">
                  <MainButton
                    disabled={true}
                    title={"Se connecter"}
                    navigate={navigate}
                    callback={async () => {
                      if (cgau && creds.emailAddress != "") {
                        console.log("CREDD_OK", creds);
                        // await setCguOk_rd();
                        await sendSignInLinkEmail_rd({ creds: creds, navigate: navigate, signInPersistence: signInPersistence });
                      } else if (creds.emailAddress === "") {
                        ToastWarn("Veuillez renseigné une adresse email.");
                      } else if (!cgau) {
                        ToastWarn("Veuillez accepté les CGU.");
                      }
                    }}
                  />
                </div>
              </form>

              <p className="text-[#BEC4C] absolute bottom-0 text-center text-xs w-full font-Poppins-Light">Fait pour la planète par lokalité © - 2022</p>
            </div>
          </div>
          <div className="bg-[#F3F5F7] absolute right-0 top-0 rounded-2xl h-full w-[530px] flex justify-center">
            <div className="relative top-20 font-PoetsenOne">
              <SignupGuy />
              <h1 className="relative text-4xl w-[180px] text-center left-20 top-[25px]">Bienvenue</h1>
              <div className="relative text-4xl w-[180px] text-center left-[70px] top-[35px] flex align-middle">
                <h1>chez</h1>
                <h1 className="text-[#169A6A] relative left-3">Lokalité</h1>
              </div>
              <p className="relative text-center w-[220px] left-[70px] top-[50px] text-xs font-Poppins-Light">Évaluer, réduire et communiquer son impact environemental en toute simplicité</p>
            </div>
          </div>
        </div>
        <img src={logo} alt="logo" className="absolute h-[320px] transparent left-[965px] top-[120px] opacity-30" />
      </div>
    </>
  );
};

export default SigninPage;
